/**
 * WhatsApp configuration
 */
export const WHATSAPP_NUMBER = '+33745800515';
export const WHATSAPP_MESSAGE = 'Bonjour je souhaite déposer mon CV';

/**
 * Generates a WhatsApp link with an optional custom message
 * @param message - Optional custom message (defaults to WHATSAPP_MESSAGE)
 * @returns WhatsApp API URL
 */
export function getWhatsAppLink(message = WHATSAPP_MESSAGE): string {
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(message)}`;
}